import React, { useState } from 'react';
import UserEditModal from '../components/AdminUsersPage/UserEditModal';
import UserDeleteModal from '../components/AdminUsersPage/UserDeleteModal';
import SearchFilter from '../components/SearchFilter/SearchFilter';
import UsersTable from '../components/AdminUsersPage/UsersTable';
import UsersBulkActions from '../components/AdminUsersPage/UsersBulkActions';
import useUserActions from '../hooks/AdminUsersPage/useUserActions';
import AdminTableLoadingSpinner from '../components/Common/AdminTableLoadingSpinner';

const AdminUsersPage = () => {
  const [editUser, setEditUser] = useState(null);
  const [deleteUser, setDeleteUser] = useState(null); 
  const {
    filteredUsers,
    selectedUsers,
    clearSelectedUsers,
    loadUsers,
    handleFilter,
    handleSelectAll,
    handleUserSelect,
    isLoading,
  } = useUserActions();

  return (
    <div className="admin-page">
      <div className="admin-page__intro">
        <h1>Users</h1>
      </div>

      <div className="admin-page__content">
        <div className="admin-page__tools">
          <SearchFilter onFilter={handleFilter} />
          <UsersBulkActions
            selectedUsers={selectedUsers}
            clearSelectedUsers={clearSelectedUsers}
            loadUsers={loadUsers}
          />
        </div>

        {isLoading ? (
          <AdminTableLoadingSpinner />
        ) : (
          <>
            <UsersTable
              users={filteredUsers}
              onEdit={setEditUser}
              onDelete={setDeleteUser}
              onUserSelect={handleUserSelect}
              selectedUsers={selectedUsers}
              onSelectAll={handleSelectAll}
            />
            <div className="admin-page__footer">
              <p>Users count: {filteredUsers.length}</p>
            </div>
          </>
        )}

      </div>

      <UserEditModal
        isOpen={!!editUser}
        onClose={() => setEditUser(null)}
        onSuccess={() => {
          loadUsers();
          setEditUser(null);
        }}
        user={editUser}
      />

      <UserDeleteModal
        isOpen={!!deleteUser}
        onClose={() => setDeleteUser(null)}
        onSuccess={() => {
          loadUsers();
          setDeleteUser(null);
        }}
        user={deleteUser}
      />
    </div>
  );
};

export default AdminUsersPage;